import React from "react";
import { PackageOpen, Receipt, Truck } from "lucide-react";

const POINTS = [
  {
    icon: Receipt,
    title: "Priced at what we paid",
    body: "Every item here is listed at our cost. There is no margin built in and nothing marked up before being marked down.",
  },
  {
    icon: PackageOpen,
    title: "Genuine surplus and superseded",
    body: "Overstock, discontinued lines and kits left over from builds. All new unless the listing says otherwise - never seconds or damaged goods.",
  },
  {
    icon: Truck,
    title: "We go backwards on most of it",
    body: "Card fees, shelf space and postage all come out of our end. We would rather it ended up on someone's 4WD than sat in the shed another year.",
  },
];

/** The cost-price explainer that sits at the top of the surplus stock shop. */
export default function CostPriceExplainer() {
  return (
    <section
      className="relative overflow-hidden rounded-xl border p-6 sm:p-8"
      style={{
        borderColor: "rgba(198,162,74,0.28)",
        background:
          "linear-gradient(135deg, rgba(198,162,74,0.09) 0%, rgba(14,18,16,0) 55%), var(--nq-ink)",
      }}
      data-testid="cost-price-explainer"
    >
      <span
        className="inline-block rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em]"
        style={{ background: "var(--nq-gold)", color: "var(--nq-black)" }}
      >
        Cost price · no markups
      </span>

      <h2 className="mt-4 max-w-3xl text-2xl font-bold leading-tight sm:text-3xl">
        We are clearing genuine surplus stock at{" "}
        <span className="gold-text">exactly what it cost us</span>.
      </h2>

      <p className="mt-3 max-w-2xl text-sm leading-relaxed text-[color:var(--nq-stone)] md:text-base">
        After 60-odd years of fitting suspension in North Queensland you end up with a shed full
        of good gear that no longer moves - superseded kits, overstock, parts ordered for builds
        that changed direction. It is all listed here at our buy price. Once card fees, storage
        and postage come out we are behind on most of it, and we have made peace with that. Better
        on your 4WD than on our shelf.
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {POINTS.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="rounded-lg border p-4"
            style={{ borderColor: "rgba(255,255,255,0.08)", background: "rgba(255,255,255,0.02)" }}
          >
            <Icon className="h-5 w-5 gold-text" />
            <p className="mt-2 text-sm font-semibold">{title}</p>
            <p className="mt-1 text-xs leading-relaxed text-[color:var(--nq-stone)]">{body}</p>
          </div>
        ))}
      </div>

      <p className="mt-5 text-xs text-[color:var(--nq-stone)]">
        One of most items - when it is gone, it is gone. Not sure a part suits your vehicle? Ask us
        before you buy and we will check it for you.
      </p>
    </section>
  );
}
